//import angular from 'angular';

    angular.module('app.directives')
        .directive(
            'btnPrimary', [
                function () {
                    return {
                        replace: false,
                        restrict: 'C',
                        //require: '^ocForm',
                        link: function (scope, elem, attr) {
                            scope.$on('form:submit', function () {
                                if ((attr.ngShow && scope.$eval(attr.ngShow) === false) || (attr.ngHide && scope.$eval(attr.ngHide) === true)) {
                                    // hidden
                                    return;
                                }

                                if (!attr.disabled && !elem[0].classList.contains('disabled')) {
                                    elem.click();
                                }
                            });
                        }
                    };
                }
            ]
        );
